module.exports = __webpack_public_path__ + "img/per2.065ce735.gif";